export const ORDER_CARD_BY_ID = (orderId: string): string => `/order-card/${orderId}`;
export const API_USER_ACTION_URL = '/user';
